"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DefaultPrompt;
var _react = _interopRequireDefault(require("react"));
var _shieldNotice = _interopRequireDefault(require("cccisd-icons/shield-notice"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DefaultPrompt(_ref) {
  var product = _ref.product;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].defaultPrompt
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].icon
  }, /*#__PURE__*/_react["default"].createElement(_shieldNotice["default"], null)), /*#__PURE__*/_react["default"].createElement("h1", null, product.label, " requires an active license to use."), /*#__PURE__*/_react["default"].createElement("p", null, "Licenses are active for ", /*#__PURE__*/_react["default"].createElement("strong", null, product.durationMonths, " months"), " before requiring a renewal."));
}